import {baseUrl} from '@/constants/app'
import authService from '@/services/auth/authService'
import helper from '@/resources/helpers/helpers'

/**
 * Abre un documento protegido del backend.
 *
 * Los documentos ya no se sirven como ficheros estáticos públicos: el endpoint
 * exige el guard auth:api. Por eso hay que pedirlos con el token (Authorization)
 * y la plataforma activa (X-PLATFORM, para que el backend seleccione la BD
 * correcta vhe/gei), recibir el binario como blob y abrirlo en una pestaña nueva.
 *
 * Se envía Accept: application/json para que un token caducado devuelva 401
 * (res.ok === false -> toast) en lugar de un 302 a /login que fetch seguiría
 * silenciosamente.
 *
 * @param {string} path Ruta del documento devuelta por el backend (p.ej.
 *                       "storage/documents_vhe_installations/Datos/.../fichero.pdf").
 */
export async function openDocument(path) {
	if (!path) {
		return
	}

	const url = baseUrl + path
	const token = authService.accessToken()
	const platform = authService.activePlatform()

	const headers = {
		Authorization: `Bearer ${token}`,
		Accept: 'application/json',
	}

	if (platform) {
		headers['X-PLATFORM'] = platform
	}

	try {
		const res = await fetch(url, {headers})

		if (!res.ok) {
			helper.showToast('No se pudo abrir el documento', 'AlertTriangleIcon', 'danger')
			return
		}

		const blobUrl = URL.createObjectURL(await res.blob())
		window.open(blobUrl, '_blank')
		setTimeout(() => URL.revokeObjectURL(blobUrl), 30000)
	} catch (e) {
		helper.showToast('No se pudo abrir el documento', 'AlertTriangleIcon', 'danger')
	}
}

export default {openDocument}
